import cn from 'classnames'
import * as R from 'ramda'
import type { Dispatch, SetStateAction } from 'react'
import { useCallback } from 'react'

import Card from 'components/uiKit/Card'
import Checkbox from 'components/uiKit/Checkbox'
import { Tooltip } from 'components/uiKit/Dropdown'
import { KitSize } from 'components/uiKit/KitTypes'
import Loader from 'components/uiKit/Loader'
import { Typography } from 'components/uiKit/Typography'
import { t } from 'services/Translation'
import type { FinderItem } from 'store/models/entry.model'
import type { FileTypeEnum } from 'utils/fileTypes'
import { testProps } from 'utils/test/qaData'
import { isFileProcessing, isFinderFolder } from 'utils/useFinder'

import { FinderFileIcons } from '../../FinderFileIcons'
import { Description } from '../Description'
import * as s from './GridItemModal.module.scss'

interface IFinderItem {
  item: FinderItem
  onClick: (item: FinderItem) => void
  onChangeSelection: Dispatch<SetStateAction<FinderItem[]>>
  selectedItems: FinderItem[]
  clearQuery: () => void
  checkbox?: boolean
}

const GridItemModal: React.FC<IFinderItem> = ({
  item,
  onClick,
  onChangeSelection,
  selectedItems,
  clearQuery,
  checkbox,
}) => {
  const typeFile = item.type?.split('/')[0] as Exclude<FileTypeEnum, FileTypeEnum.FONT> | undefined
  const showLoader = isFileProcessing(item)

  const onSelectItem = useCallback(
    (val: boolean) => {
      onChangeSelection((prev: FinderItem[]) => {
        if (!val) {
          return R.filter<FinderItem, FinderItem[]>(({ id }) => id !== item.id, prev)
        } else {
          return [...prev, item]
        }
      })
    },
    [item, onChangeSelection],
  )

  const selected = !!selectedItems.find((i) => i.id === item.id)

  const handleClick = () => {
    // if (showLoader) {
    //   return
    // }

    if (selectedItems.length) {
      onChangeSelection((prev) => {
        if (prev.find((i) => i.id === item.id)) {
          return R.filter<FinderItem, FinderItem[]>(({ id }) => id !== item.id, prev)
        }

        return [...prev, item]
      })
      return
    }
    onClick(item)
    clearQuery()
    onChangeSelection([])
  }

  return (
    <div
      className={s.item}
      key={item.id}
      {...testProps({ el: 'fileItem', label: item.name, id: item.id })}
    >
      <Card name='fileModalCard' onClick={handleClick} selected={selected} size={KitSize.XS} fluid>
        <div className={cn(s.block)}>
          <div className={s.blockWrapper}>
            <FinderFileIcons item={item} typeFile={typeFile} />
          </div>
        </div>
      </Card>
      <div className={s.title}>
        <div className={cn(s.name)}>
          {checkbox && <Checkbox name='resource' onChange={onSelectItem} value={selected} />}
          <div onClick={handleClick}>
            <Typography
              color='inherit'
              indents={{ marginRight: 8 }}
              rows={1}
              styleType={isFinderFolder(item) ? 'link' : 'base'}
              tooltip={item.name}
              wordBreak='break-word'
            >
              {item.name}
            </Typography>
          </div>
          {showLoader && (
            <Tooltip overlay={t('page.finder.videoProcessingInfo')}>
              <Loader name='loader' styleType='inline' />
            </Tooltip>
          )}
        </div>
        <Description item={item} />
      </div>
    </div>
  )
}

export default GridItemModal
